export default __webpack_public_path__ + "static/AeroFIX-2.0-06ff52cd12675ad5ed01409caacedaab.jpg";